const GSM_BASIC =
  "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ ÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";
const GSM_EXTENDED = new Set("^{}\\[~]|€".split(""));
const GSM_BASIC_SET = new Set(GSM_BASIC.split(""));

const isGsmChar = (char: string) =>
  GSM_BASIC_SET.has(char) || GSM_EXTENDED.has(char);

const gsmLength = (text: string) =>
  Array.from(text).reduce(
    (count, char) => count + (GSM_EXTENDED.has(char) ? 2 : 1),
    0
  );

export const smsSegmentInfo = (text: string) => {
  const characters = Array.from(text);
  if (characters.length === 0) {
    return { characters: 0, segments: 0, encoding: "gsm" as const };
  }
  const isGsm = characters.every(isGsmChar);
  if (isGsm) {
    const length = gsmLength(text);
    const segments = length <= 160 ? 1 : Math.ceil(length / 153);
    return { characters: length, segments, encoding: "gsm" as const };
  }
  const length = characters.length;
  const segments = length <= 70 ? 1 : Math.ceil(length / 67);
  return { characters: length, segments, encoding: "ucs2" as const };
};
